export const version = 'v2.2.4-2220-g20e398bad'
